exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#chargeServiceExplain {\n  font-size: .14rem;\n  padding: .07rem .13rem .25rem;\n  margin-bottom: .25rem;\n}\n#chargeServiceExplain h3 {\n  font-size: 0.14rem;\n  line-height: 1.7;\n  padding: 0.05rem 0;\n}\n#chargeServiceExplain p {\n  line-height: 1.7;\n}\n#chargeServiceExplain article {\n  margin-top: .24rem;\n}\n#chargeServiceExplain article h2 {\n  font-size: .14rem;\n}\n#chargeServiceExplain section {\n  margin-top: .12rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/chargeServiceExplain/index.less
// module id = 281
// module chunks = 0